import React from "react";
import { Link } from "react-router-dom";
import "./Tours.css";

import tour1 from "../assets/walking.jpg";
import tour2 from "../assets/private.jpg";

import { Clock, MapPin, Users } from "lucide-react";
export default function Tours() {
  const tours = [
  {
    id: 1,
    title: "Gjirokaster Free Walking Tour",
    image: tour1,
    badge: "Popular",
    description:
      "Discover the magic of Gjirokaster on our 2-hour Free Walking Tour, led by certified local guides...",
    details: [
      { icon: "clock", text: "2 hours" },
      { icon: "location", text: "Rruga Zejtareve (To the left of Rrapi Restaurant)" },
      { icon: "people", text: "Up to 15 people" },
    ],
    price: "Free (Tips Based)",
    link: "/tours/free-walking",
  },
  {
    id: 2,
    title: "Gjirokaster Private Tour (Bazaar & Castle)",
    image: tour2,
    description:
      "Enjoy Gjirokaster in a more personal, flexible, and immersive way with a guide dedicated entirely to you...",
    details: [
      { icon: "clock", text: "Flexible" },
      { icon: "location", text: "Customizable" },
      { icon: "people", text: "Any group size" },
    ],
    price: "Custom Price",
    link: "/tours/berat-castle-private",
  },
];


   const icons = {
  clock: <Clock size={18} />,
  location: <MapPin size={18} />,
  people: <Users size={18} />,
};


  return (
    <section id="tours" className="tours-section">
      <h2 className="tours-title">Our Tours</h2>
      <p className="tours-description">
Discover the charm and fascinating history of Gjirokaster through our carefully guided tours. Whether you prefer a free walking tour or a private experience, we offer options for every type of traveler.
      </p>

  <div className="tour-grid">
  {tours.map((tour) => (
    <Link key={tour.id} to={tour.link} className="tour-card-link">
      <div className="tour-card">
        <div className="tour-image">
          <img src={tour.image} alt={tour.title} />
        </div>

        <div className="tour-content">
          <h3>{tour.title}</h3>
          <p>{tour.description}</p>

          <ul className="tour-details">
            {tour.details.map(({ icon, text }, index) => (
              <li key={index}>
                {icons[icon]}
                <span>{text}</span>
              </li>
            ))}
          </ul>

          <div className="tour-bottom">
            <span className="tour-price">{tour.price}</span>
            <button className="tour-btn">Learn More</button>
          </div>
        </div>
      </div>
    </Link>
  ))}
</div>


    </section>
  );
}
